<ng-container
  *ngIf="{
    allNews: allNews$ | async,
    latestNewsItem: latestNewsItem$ | async,
    newsList: newsList$ | async,
    showMorePageUrl: showMorePageUrl$ | async,
    styleClasses: styleClasses$ | async
  } as data"
>
  <div class="container no-horizontal-padding news-list" #containerSizeRef>
    <div class="row no-gutters">
      <div class="col-12">
        <h2>{{ 'labels.news_title' | cxTranslate }}</h2>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="!showContentsListStyle && !!data.latestNewsItem; else contentsListTemplate">
      <ng-container *pyContainerSize="{ min: 850 }; ref: containerSizeRef; then: wideRow; else: smallRow"></ng-container>
    </div>
  </div>

  <ng-template #contentsListTemplate>
    <ng-container *ngIf="showContentsListStyle">
      <div class="row no-gutters all-news py-4 border-bottom" *ngFor="let news of data.allNews">
        <div class="col-auto pr-4">
          <div class="news-image">
            <img [pyMedia]="news.featuredImage" [alt]="news.title" />
          </div>
        </div>
        <div class="col">
          <cx-generic-link [url]="news.label">
            <h5 class="mb-2">{{ news.title }}</h5>
          </cx-generic-link>
          <p class="news-description">{{ news.description }}</p>
          <div class="news-date">
            <ng-container *ngTemplateOutlet="dateTemplate; context: { $implicit: news.publicationDate }"></ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #wideRow>
    <div class="latest-news" [ngClass]="{ 'col-8': !!data.newsList?.length, 'col-12': !data.newsList?.length }">
      <cx-generic-link [url]="data.latestNewsItem.label">
        <div class="row no-gutters" [ngClass]="{ 'h-100 border-right pr-4 mr-4': !!data.newsList?.length }">
          <ng-container
            *ngTemplateOutlet="latestItemTemplate; context: { $implicit: { news: data.latestNewsItem, imageFirst: false } }"
          ></ng-container>
        </div>
      </cx-generic-link>
    </div>

    <div class="col-4 news" *ngIf="!!data.newsList?.length">
      <cx-generic-link *ngFor="let news of data.newsList" [url]="news.label">
        <div class="row no-gutters py-4 border-bottom">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: news }"></ng-container>
        </div>
      </cx-generic-link>
      <ng-container *ngTemplateOutlet="showMoreTemplate"></ng-container>
    </div>
  </ng-template>

  <ng-template #smallRow>
    <div class="col-12 latest-news">
      <cx-generic-link [url]="data.latestNewsItem.label">
        <div class="row no-gutters py-4 border-bottom">
          <ng-container
            *ngTemplateOutlet="latestItemTemplate; context: { $implicit: { news: data.latestNewsItem, imageFirst: true } }"
          ></ng-container>
        </div>
      </cx-generic-link>
    </div>

    <div class="col-12 news" *ngIf="!!data.newsList?.length">
      <cx-generic-link *ngFor="let news of data.newsList" [url]="news.label">
        <div class="row no-gutters py-4 border-bottom">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: news }"></ng-container>
        </div>
      </cx-generic-link>
      <ng-container *ngTemplateOutlet="showMoreTemplate; context: { $implicit: { reverse: true } }"></ng-container>
    </div>
  </ng-template>

  <ng-template #latestItemTemplate let-data>
    <div class="col">
      <span class="news-title" [class.large-text]="!data.imageFirst">{{ data.news.title }}</span>
      <p class="news-description" [class.large-text]="!data.imageFirst">{{ data.news.description }}</p>
      <div class="news-date" [class.large-text]="!data.imageFirst">
        <ng-container *ngTemplateOutlet="dateTemplate; context: { $implicit: data.news.publicationDate }"></ng-container>
      </div>
    </div>

    <div class="col-auto" [ngClass]="{ 'col-auto pl-4': !data.imageFirst, 'col-12 order-first pb-4': data.imageFirst }">
      <div class="news-image" [class.full-width]="data.imageFirst">
        <img [pyMedia]="data.news.featuredImage" [alt]="data.news.title" />
      </div>
    </div>
  </ng-template>

  <ng-template #itemTemplate let-news>
    <div class="col">
      <cx-generic-link [url]="news.label">
        <h5>{{ news.title }}</h5>
      </cx-generic-link>
      <div class="news-date">
        <ng-container *ngTemplateOutlet="dateTemplate; context: { $implicit: news.publicationDate }"></ng-container>
      </div>
    </div>
    <div class="col-auto pl-4">
      <div class="news-image">
        <img [pyMedia]="news.featuredImage" [alt]="news.title" />
      </div>
    </div>
  </ng-template>

  <ng-template #showMoreTemplate let-reverse>
    <div class="row no-gutters" *ngIf="!!data.showMorePageUrl">
      <cx-generic-link class="btn btn-link show-more-button px-0" [url]="data.showMorePageUrl">
        <i *ngIf="reverse" nz-icon nzType="arrow-right"></i>
        <span>{{ 'news.moreNews_action' | cxTranslate }}</span>
        <i *ngIf="!reverse" nz-icon nzType="arrow-right"></i>
      </cx-generic-link>
    </div>
  </ng-template>

  <ng-template #dateTemplate let-date>
    <ng-container *ngIf="!hasClass(data.styleClasses, 'news-hide-time-created')">{{ date | cxDate : 'dateTime' }}</ng-container>
  </ng-template>
</ng-container>
